"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXPENSE_POLICY_VALIDATION_TYPES = exports.EXPENSE_POLICY_VALIDATION_PERIODS = exports.EXPENSE_POLICY_MODES = void 0;
var EXPENSE_POLICY_MODES = exports.EXPENSE_POLICY_MODES = ['TOTAL', 'SUBTOTAL'];
var EXPENSE_POLICY_VALIDATION_PERIODS = exports.EXPENSE_POLICY_VALIDATION_PERIODS = ['DAY', 'EVENT'];
var EXPENSE_POLICY_VALIDATION_TYPES = exports.EXPENSE_POLICY_VALIDATION_TYPES = ['AMOUNT', 'PERCENTAGE'];